const modalLocationElms = {
  modal: document.querySelector(".location"),
  close: document.querySelector(".location .container-modal .close-modal"),
  overlay: document.querySelector(".modal-overlay"),
  continue: document.querySelector(".btn-continue.submit-location"),
  continueCustomer: document.querySelector(".btn-continue.submit-address"),
};

const setDataLocationFromLoggedUser = async () => {
  await getRegionsOms(null);
  if (locationStorage) setStorageModalLocation();
};

const changeTextButton = (isLocation) => {
  isLocation
    ? $("#gestion-address").text("Direcciones guardadas")
    : $("#gestion-address").text("Agregar Dirección");
};
const _showModalLocation = (selectionChange) => {
  const isAddressLoggedUser = getITemLocalStorage("locations");

  if (isAddressLoggedUser?.type_modal === "address" && selectionChange) {
    $(".address-modal").removeClass("d-none");
    $(".locations-modal").addClass("d-none");
    changeTextButton(false);
    return;
  }

  if (isAddressLoggedUser?.type_modal === "location" && selectionChange) {
    $(".address-modal").addClass("d-none");
    $(".locations-modal").removeClass("d-none");
    changeTextButton(true);
    return;
  }

  if (isAddressLoggedUser?.type_modal === "location" && !selectionChange) {
    $(".locations-modal").addClass("d-none");
    $(".address-modal").removeClass("d-none");
    changeTextButton(false);
    setITemLocalStorage("locations", {
      ...isAddressLoggedUser,
      type_modal: "address",
    });
    return;
  }

  if (isAddressLoggedUser?.type_modal === "address" && !selectionChange) {
    $(".address-modal").addClass("d-none");
    $(".locations-modal").removeClass("d-none");
    changeTextButton(true);
    setITemLocalStorage("locations", {
      ...isAddressLoggedUser,
      type_modal: "location",
    });
    return;
  }

  if (
    $(".address-modal").hasClass("d-none") &&
    !selectionChange &&
    !Boolean(isAddressLoggedUser?.type_modal)
  ) {
    $(".address-modal").removeClass("d-none");
    $(".locations-modal").addClass("d-none");
    changeTextButton(false);
    return;
  }

  if (
    $(".locations-modal").hasClass("d-none") &&
    !selectionChange &&
    !Boolean(isAddressLoggedUser?.type_modal)
  ) {
    $(".address-modal").addClass("d-none");
    $(".locations-modal").removeClass("d-none");
    changeTextButton(true);
    return;
  }
};

const openModalLocation = async () => {
  let _element = document.getElementById("message-location");
  if (!_element?.classList?.contains("hidden"))
    _element.classList.add("hidden");
  await getRegionsOms(null);
  if (locationStorage) setStorageModalLocation();
  _showModalLocation(true);
  document.body.style.overflow = "hidden";
  modalLocationElms.modal.classList.add("open");
  modalLocationElms.overlay.classList.add("open");
};

const setButtonAddtoCart = () => {
  const isProductPage = $("body").hasClass("template-product");

  if (isProductPage && Boolean(method?.selected)) {
    document.querySelectorAll(".add-cart-button").forEach((button) => {
      button.classList.remove("disabled");
      button.classList.remove("initial-state");
      button.innerText = "Agregar al carrito";
    });
  }
};

const closeModalLocation = () => {
  document.body.style.overflow = "auto";
  modalLocationElms.modal.classList.remove("open");
  modalLocationElms.overlay.classList.remove("open");
  setButtonAddtoCart();
};

// Event listeners
window.addEventListener("is-open-modal-location", (e) => {
  if (e?.detail?.firstOpen === "first")
    modalLocationElms.close.style.visibility = "hidden";
  else modalLocationElms.close.style.visibility = "visible";
  if (!e?.detail?.open) return closeModalLocation();
  openModalLocation();
});

modalLocationElms.close.addEventListener("click", closeModalLocation);
// modalLocationElms?.continue?.addEventListener("click", closeModalLocation);
modalLocationElms?.continueCustomer?.addEventListener(
  "click",
  closeModalLocation
);
